
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/peerconnect",
      function () {
        return require("private-next-pages/peerconnect.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/peerconnect"])
      });
    }
  